<template>
  <div
    class=""
    v-if="disabled"
  >
    <slot name="drawer" />
  </div>
  <div
    class="c-verticalDrawer"
    :class="[{ '-is-active': isActive }, { '-is-fixed': isFixed }]"
    v-else
  >
    <slot />
    <div
      class="c-verticalDrawer_drawer"
      :class="[{ '-is-active': isActive }, { '-is-fixed': isFixed }]"
      :style="{
        [direction]: isActive ? wrapperDirectionValue : '100%',
        transition: `${direction} .2s ease`,
        zIndex: zIndex - 1,
        height: wrapperHeight
      }"
    >
      <slot name="drawer" />
    </div>
    <transition name="fade">
      <div
        class="c-verticalDrawer_overlay"
        :style="{ zIndex: zIndex - 2 }"
        v-show="isActive"
        @click="close"
      ></div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'VerticalDrawer',
  props: {
    minBlankAreaHeight: {
      type: Number,
      default: 60
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isFixed: {
      type: Boolean,
      default: false
    },
    isFixedHtmlClass: {
      type: String,
      default: ''
    },
    isScrollable: {
      type: Boolean,
      default: true
    },
    direction: {
      type: String,
      default: 'bottom'
    },
    zIndex: {
      type: Number,
      default: 2
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      $contentEl: null,
      contentHeight: null,
      drawerHeight: null,
      windowHeight: null,
      isReady: false
    }
  },
  mounted() {},
  beforeDestroy() {
    window.removeEventListener('resize', this.setHeights)
  },
  methods: {
    initDrawer() {
      // set content styles
      this.$contentEl = this.$slots.default[0].elm
      this.$contentEl.style.position = 'relative'
      this.$contentEl.style.zIndex = this.zIndex
      this.$contentEl.style.width = '100%'
      this.contentHeight = this.$contentEl.offsetHeight

      // set drawer styles
      this.setDrawerHeight()

      this.windowHeight = window.innerHeight
      this.$util.on('resize', window, this.setHeights)
      this.isReady = true
    },
    setDrawerHeight() {
      const $drawerEl = this.$slots.drawer[0].elm
      this.drawerHeight = $drawerEl.offsetHeight

      if (this.isScrollable) {
        $drawerEl.style.overflowY = 'auto'
      }
    },
    setHeights() {
      this.windowHeight = window.innerHeight
      this.contentHeight = this.$contentEl.offsetHeight
    },
    close() {
      this.$emit('close')
    }
  },
  watch: {
    isActive(v) {
      if (v) {
        document.documentElement.classList.add('-is-clipped')
        if (this.isFixed) {
          document.documentElement.classList.add(this.isFixedHtmlClass)
        }
        this.$nextTick(this.initDrawer)
      } else {
        document.documentElement.classList.remove('-is-clipped')
        if (this.isFixed) {
          document.documentElement.classList.remove(this.isFixedHtmlClass)
        }
        window.removeEventListener('resize', this.setHeights)
      }

      return this.$emit('active-change', v)
    },
    disabled(v) {
      if (v) this.close()
    }
  },
  computed: {
    wrapperDirectionValue() {
      if (this.isHigherThanWindow) {
        return `calc(100% + ${this.minBlankAreaHeight}px - ${this.windowHeight}px`
      } else {
        return `calc(100% - ${this.drawerHeight + this.contentHeight}px)`
      }
    },
    wrapperHeight() {
      if (this.isHigherThanWindow) {
        return `${this.windowHeight - this.minBlankAreaHeight - this.contentHeight}px`
      } else {
        return 'auto'
      }
    },
    isHigherThanWindow() {
      return this.windowHeight <= this.drawerHeight + this.contentHeight + this.minBlankAreaHeight
    }
  }
}
</script>
<style lang="scss" scoped>
.c-verticalDrawer {
  position: relative;
  width: 100%;

  &_overlay {
    @include overlay;

    z-index: 0;
  }

  &_drawer {
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: $color-white;
    opacity: 0;
    &.-is-active {
      opacity: 1;

      &.-is-fixed {
        position: fixed;
      }
    }
  }

  &.-is-active {
    &.-is-fixed {
      position: fixed;
      top: 0;
    }
  }
}
</style>
